import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const printButton = ({ theme }: { theme: Theme }) => css`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0;
  margin: 0;
  color: ${theme.palette.primary.dark};

  &:hover {
    cursor: pointer;
    background-color: ${theme.palette.primary.dark}10;
  }
`
